module.exports = __webpack_public_path__ + "static/media/addingRichTextAnimation.4ab576e7.gif";